import useIsFeatureFlagEnabled from './useIsFeatureFlagEnabled';

const useEnableKpi = () =>
  useIsFeatureFlagEnabled('enableKpi');

export default useEnableKpi;
